import { render, staticRenderFns } from "./StockPriceIcon.vue?vue&type=template&id=6a724a70"
import script from "./StockPriceIcon.vue?vue&type=script&lang=js"
export * from "./StockPriceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports